exports.technologies = [
    { id: 1, name: 'iOS', svgName: 'ios_logo', width: 390.95, height: 175.21, selected_barcodes: [] },
    { id: 2, name: 'Android', svgName: 'android_logo', width: 157.53, height: 24, selected_barcodes: [] },
    { id: 3, name: 'WebAssembly', svgName: 'wasm_logo', width: 551.27, height: 98.04, selected_barcodes: [] },
    { id: 4, name: 'Linux', svgName: 'linux_logo', width: 551.27, height: 98.04, selected_barcodes: [] },
    { id: 5, name: 'Windows (DLL)', svgName: 'windows_logo', width: 551.27, height: 98.04, selected_barcodes: [] },
    { id: 6, name: 'Flutter', svgName: 'flutter_logo', width: 172, height: 48, selected_barcodes: [] },
    { id: 7, name: 'React Native', svgName: 'react_logo', width: 145.38, height: 40, selected_barcodes: [] },
    { id: 8, name: 'Capacitor', svgName: 'capacitor_logo', width: 800, height: 152.38, selected_barcodes: [] },
    { id: 9, name: 'Cordova', svgName: 'cordova_logo', width: 48, height: 48, selected_barcodes: [] },
    { id: 10, name: '.NET Maui', svgName: 'net_maui_logo', width: 673, height: 216, selected_barcodes: [] },
    { id: 11, name: 'NativeScript', svgName: 'nativescript_logo', width: 673, height: 216, selected_barcodes: [] },
    { id: 12, name: 'Python', svgName: 'python_logo', width: 673, height: 216, selected_barcodes: [] },
    { id: 13, name: 'C#', svgName: 'c_sharp_logo', width: 673, height: 216, selected_barcodes: [] },
];

exports.unsupported_technologies = []

exports.barcodes = {
    'AZTEC' 		: 'Aztec Code',
    'CODABAR' 		: 'Codabar',
    'CODE11'		: 'Code 11',
    'CODE25'		: 'Code 25',
    'CODE39' 		: 'Code 32 / 39',
    'CODE93' 		: 'Code 93',
    'CODE128'		: 'Code 128',
    'DATABAR'		: 'Databar',
    'DATAMATRIX'	: 'Data Matrix',
    'DOTCODE'		: 'DotCode',
    'EANUPC' 		: 'EAN & UPC',
    'MaxiCode' 	 	: 'MaxiCode',
    'MSI' 			: 'MSI Plessey',
    'PDF417'		: 'PDF417',
    'QR' 			: 'QR Code',
    'TELEPEN'		: 'Telepen',
    'MRZ'			: 'MRZ',
    'VIN'			: 'Vin',
    'POSTAL' 		: 'Postal',
}

exports.support_countries = [
    {
        flag2: "af",
        flag: "afg",
        name: "Afghanistan",
    },
    {
        flag2: "ax",
        flag: "ala",
        name: "Åland Islands",
    },
    {
        flag2: "al",
        flag: "alb",
        name: "Albania",
    },
    {
        flag2: "dz",
        flag: "dza",
        name: "Algeria",
    },
    {
        flag2: "as",
        flag: "asm",
        name: "American Samoa",
    },
    {
        flag2: "ad",
        flag: "and",
        name: "Andorra",
    },
    {
        flag2: "ao",
        flag: "ago",
        name: "Angola",
    },
    {
        flag2: "ai",
        flag: "aia",
        name: "Anguilla",
    },
    {
        flag2: "aq",
        flag: "ata",
        name: "Antarctica",
    },
    {
        flag2: "ag",
        flag: "atg",
        name: "Antigua and Barbuda",
    },
    {
        flag2: "ar",
        flag: "arg",
        name: "Argentina",
    },
    {
        flag2: "am",
        flag: "arm",
        name: "Armenia",
    },
    {
        flag2: "aw",
        flag: "abw",
        name: "Aruba",
    },
    {
        flag2: "au",
        flag: "aus",
        name: "Australia",
    },
    {
        flag2: "at",
        flag: "aut",
        name: "Austria",
    },
    {
        flag2: "az",
        flag: "aze",
        name: "Azerbaijan",
    },
    {
        flag2: "bs",
        flag: "bhs",
        name: "Bahamas",
    },
    {
        flag2: "bh",
        flag: "bhr",
        name: "Bahrain",
    },
    {
        flag2: "bd",
        flag: "bgd",
        name: "Bangladesh",
    },
    {
        flag2: "bb",
        flag: "brb",
        name: "Barbados",
    },
    {
        flag2: "by",
        flag: "blr",
        name: "Belarus",
    },
    {
        flag2: "be",
        flag: "bel",
        name: "Belgium",
    },
    {
        flag2: "bz",
        flag: "blz",
        name: "Belize",
    },
    {
        flag2: "bj",
        flag: "ben",
        name: "Benin",
    },
    {
        flag2: "bm",
        flag: "bmu",
        name: "Bermuda",
    },
    {
        flag2: "bt",
        flag: "btn",
        name: "Bhutan",
    },
    {
        flag2: "bo",
        flag: "bol",
        name: "Bolivia (Plurinational State of)",
    },
    {
        flag2: "bq",
        flag: "bes",
        name: "Bonaire, Sint Eustatius and Saba",
    },
    {
        flag2: "ba",
        flag: "bih",
        name: "Bosnia and Herzegovina",
    },
    {
        flag2: "bw",
        flag: "bwa",
        name: "Botswana",
    },
    {
        flag2: "bv",
        flag: "bvt",
        name: "Bouvet Island",
    },
    {
        flag2: "br",
        flag: "bra",
        name: "Brazil",
    },
    {
        flag2: "vg",
        flag: "vgb",
        name: "Virgin Islands (British)",
    },
    {
        flag2: "io",
        flag: "iot",
        name: "British Indian Ocean Territory",
    },
    {
        flag2: "bn",
        flag: "brn",
        name: "Brunei Darussalam",
    },
    {
        flag2: "bg",
        flag: "bgr",
        name: "Bulgaria",
    },
    {
        flag2: "bf",
        flag: "bfa",
        name: "Burkina Faso",
    },
    {
        flag2: "bi",
        flag: "bdi",
        name: "Burundi",
    },
    {
        flag2: "kh",
        flag: "khm",
        name: "Cambodia",
    },
    {
        flag2: "cm",
        flag: "cmr",
        name: "Cameroon",
    },
    {
        flag2: "ca",
        flag: "can",
        name: "Canada",
    },
    {
        flag2: "cv",
        flag: "cpv",
        name: "Cabo Verde",
    },
    {
        flag2: "ky",
        flag: "cym",
        name: "Cayman Islands",
    },
    {
        flag2: "cf",
        flag: "caf",
        name: "Central African Republic",
    },
    {
        flag2: "td",
        flag: "tcd",
        name: "Chad",
    },
    {
        flag2: "cl",
        flag: "chl",
        name: "Chile",
    },
    {
        flag2: "cn",
        flag: "chn",
        name: "China",
    },
    {
        flag2: "hk",
        flag: "hkg",
        name: "Hong Kong",
    },
    {
        flag2: "mo",
        flag: "mac",
        name: "Macao",
    },
    {
        flag2: "cx",
        flag: "cxr",
        name: "Christmas Island",
    },
    {
        flag2: "cc",
        flag: "cck",
        name: "Cocos (Keeling) Islands",
    },
    {
        flag2: "co",
        flag: "col",
        name: "Colombia",
    },
    {
        flag2: "km",
        flag: "com",
        name: "Comoros",
    },
    {
        flag2: "cg",
        flag: "cog",
        name: "Congo",
    },
    {
        flag2: "cd",
        flag: "cod",
        name: "Congo, Democratic Republic of the",
    },
    {
        flag2: "ck",
        flag: "cok",
        name: "Cook Islands",
    },
    {
        flag2: "cr",
        flag: "cri",
        name: "Costa Rica",
    },
    {
        flag2: "ci",
        flag: "civ",
        name: "Côte d'Ivoire",
    },
    {
        flag2: "hr",
        flag: "hrv",
        name: "Croatia",
    },
    {
        flag2: "cu",
        flag: "cub",
        name: "Cuba",
    },
    {
        flag2: "cw",
        flag: "cuw",
        name: "Curaçao",
    },
    {
        flag2: "cy",
        flag: "cyp",
        name: "Cyprus",
    },
    {
        flag2: "cz",
        flag: "cze",
        name: "Czechia",
    },
    {
        flag2: "dk",
        flag: "dnk",
        name: "Denmark",
    },
    {
        flag2: "dj",
        flag: "dji",
        name: "Djibouti",
    },
    {
        flag2: "dm",
        flag: "dma",
        name: "Dominica",
    },
    {
        flag2: "do",
        flag: "dom",
        name: "Dominican Republic",
    },
    {
        flag2: "ec",
        flag: "ecu",
        name: "Ecuador",
    },
    {
        flag2: "eg",
        flag: "egy",
        name: "Egypt",
    },
    {
        flag2: "sv",
        flag: "slv",
        name: "El Salvador",
    },
    {
        flag2: "gq",
        flag: "gnq",
        name: "Equatorial Guinea",
    },
    {
        flag2: "er",
        flag: "eri",
        name: "Eritrea",
    },
    {
        flag2: "ee",
        flag: "est",
        name: "Estonia",
    },
    {
        flag2: "et",
        flag: "eth",
        name: "Ethiopia",
    },
    {
        flag2: "fk",
        flag: "flk",
        name: "Falkland Islands (Malvinas)",
    },
    {
        flag2: "fo",
        flag: "fro",
        name: "Faroe Islands",
    },
    {
        flag2: "fj",
        flag: "fji",
        name: "Fiji",
    },
    {
        flag2: "fi",
        flag: "fin",
        name: "Finland",
    },
    {
        flag2: "fr",
        flag: "fra",
        name: "France",
    },
    {
        flag2: "gf",
        flag: "guf",
        name: "French Guiana",
    },
    {
        flag2: "pf",
        flag: "pyf",
        name: "French Polynesia",
    },
    {
        flag2: "tf",
        flag: "atf",
        name: "French Southern Territories",
    },
    {
        flag2: "ga",
        flag: "gab",
        name: "Gabon",
    },
    {
        flag2: "gm",
        flag: "gmb",
        name: "Gambia",
    },
    {
        flag2: "ge",
        flag: "geo",
        name: "Georgia",
    },
    {
        flag2: "de",
        flag: "deu",
        name: "Germany",
    },
    {
        flag2: "gh",
        flag: "gha",
        name: "Ghana",
    },
    {
        flag2: "gi",
        flag: "gib",
        name: "Gibraltar",
    },
    {
        flag2: "gr",
        flag: "grc",
        name: "Greece",
    },
    {
        flag2: "gl",
        flag: "grl",
        name: "Greenland",
    },
    {
        flag2: "gd",
        flag: "grd",
        name: "Grenada",
    },
    {
        flag2: "gp",
        flag: "glp",
        name: "Guadeloupe",
    },
    {
        flag2: "gu",
        flag: "gum",
        name: "Guam",
    },
    {
        flag2: "gt",
        flag: "gtm",
        name: "Guatemala",
    },
    {
        flag2: "gg",
        flag: "ggy",
        name: "Guernsey",
    },
    {
        flag2: "gn",
        flag: "gin",
        name: "Guinea",
    },
    {
        flag2: "gw",
        flag: "gnb",
        name: "Guinea-Bissau",
    },
    {
        flag2: "gy",
        flag: "guy",
        name: "Guyana",
    },
    {
        flag2: "ht",
        flag: "hti",
        name: "Haiti",
    },
    {
        flag2: "hm",
        flag: "hmd",
        name: "Heard Island and McDonald Islands",
    },
    {
        flag2: "va",
        flag: "vat",
        name: "Holy See",
    },
    {
        flag2: "hn",
        flag: "hnd",
        name: "Honduras",
    },
    {
        flag2: "hu",
        flag: "hun",
        name: "Hungary",
    },
    {
        flag2: "is",
        flag: "isl",
        name: "Iceland",
    },
    {
        flag2: "in",
        flag: "ind",
        name: "India",
    },
    {
        flag2: "id",
        flag: "idn",
        name: "Indonesia",
    },
    {
        flag2: "ir",
        flag: "irn",
        name: "Iran (Islamic Republic of)",
    },
    {
        flag2: "iq",
        flag: "irq",
        name: "Iraq",
    },
    {
        flag2: "ie",
        flag: "irl",
        name: "Ireland",
    },
    {
        flag2: "im",
        flag: "imn",
        name: "Isle of Man",
    },
    {
        flag2: "il",
        flag: "isr",
        name: "Israel",
    },
    {
        flag2: "it",
        flag: "ita",
        name: "Italy",
    },
    {
        flag2: "jm",
        flag: "jam",
        name: "Jamaica",
    },
    {
        flag2: "jp",
        flag: "jpn",
        name: "Japan",
    },
    {
        flag2: "je",
        flag: "jey",
        name: "Jersey",
    },
    {
        flag2: "jo",
        flag: "jor",
        name: "Jordan",
    },
    {
        flag2: "kz",
        flag: "kaz",
        name: "Kazakhstan",
    },
    {
        flag2: "ke",
        flag: "ken",
        name: "Kenya",
    },
    {
        flag2: "ki",
        flag: "kir",
        name: "Kiribati",
    },
    {
        flag2: "kp",
        flag: "prk",
        name: "Korea (Democratic People's Republic of)",
    },
    {
        flag2: "kr",
        flag: "kor",
        name: "Korea, Republic of",
    },
    {
        flag2: "kw",
        flag: "kwt",
        name: "Kuwait",
    },
    {
        flag2: "kg",
        flag: "kgz",
        name: "Kyrgyzstan",
    },
    {
        flag2: "la",
        flag: "lao",
        name: "Lao People's Democratic Republic",
    },
    {
        flag2: "lv",
        flag: "lva",
        name: "Latvia",
    },
    {
        flag2: "lb",
        flag: "lbn",
        name: "Lebanon",
    },
    {
        flag2: "ls",
        flag: "lso",
        name: "Lesotho",
    },
    {
        flag2: "lr",
        flag: "lbr",
        name: "Liberia",
    },
    {
        flag2: "ly",
        flag: "lby",
        name: "Libya",
    },
    {
        flag2: "li",
        flag: "lie",
        name: "Liechtenstein",
    },
    {
        flag2: "lt",
        flag: "ltu",
        name: "Lithuania",
    },
    {
        flag2: "lu",
        flag: "lux",
        name: "Luxembourg",
    },
    {
        flag2: "mk",
        flag: "mkd",
        name: "North Macedonia",
    },
    {
        flag2: "mg",
        flag: "mdg",
        name: "Madagascar",
    },
    {
        flag2: "mw",
        flag: "mwi",
        name: "Malawi",
    },
    {
        flag2: "my",
        flag: "mys",
        name: "Malaysia",
    },
    {
        flag2: "mv",
        flag: "mdv",
        name: "Maldives",
    },
    {
        flag2: "ml",
        flag: "mli",
        name: "Mali",
    },
    {
        flag2: "mt",
        flag: "mlt",
        name: "Malta",
    },
    {
        flag2: "mh",
        flag: "mhl",
        name: "Marshall Islands",
    },
    {
        flag2: "mq",
        flag: "mtq",
        name: "Martinique",
    },
    {
        flag2: "mr",
        flag: "mrt",
        name: "Mauritania",
    },
    {
        flag2: "mu",
        flag: "mus",
        name: "Mauritius",
    },
    {
        flag2: "yt",
        flag: "myt",
        name: "Mayotte",
    },
    {
        flag2: "mx",
        flag: "mex",
        name: "Mexico",
    },
    {
        flag2: "fm",
        flag: "fsm",
        name: "Micronesia (Federated States of)",
    },
    {
        flag2: "md",
        flag: "mda",
        name: "Moldova, Republic of",
    },
    {
        flag2: "mc",
        flag: "mco",
        name: "Monaco",
    },
    {
        flag2: "mn",
        flag: "mng",
        name: "Mongolia",
    },
    {
        flag2: "me",
        flag: "mne",
        name: "Montenegro",
    },
    {
        flag2: "ms",
        flag: "msr",
        name: "Montserrat",
    },
    {
        flag2: "ma",
        flag: "mar",
        name: "Morocco",
    },
    {
        flag2: "mz",
        flag: "moz",
        name: "Mozambique",
    },
    {
        flag2: "mm",
        flag: "mmr",
        name: "Myanmar",
    },
    {
        flag2: "na",
        flag: "nam",
        name: "Namibia",
    },
    {
        flag2: "nr",
        flag: "nru",
        name: "Nauru",
    },
    {
        flag2: "np",
        flag: "npl",
        name: "Nepal",
    },
    {
        flag2: "nl",
        flag: "nld",
        name: "Netherlands",
    },
    {
        flag2: "nc",
        flag: "ncl",
        name: "New Caledonia",
    },
    {
        flag2: "nz",
        flag: "nzl",
        name: "New Zealand",
    },
    {
        flag2: "ni",
        flag: "nic",
        name: "Nicaragua",
    },
    {
        flag2: "ne",
        flag: "ner",
        name: "Niger",
    },
    {
        flag2: "ng",
        flag: "nga",
        name: "Nigeria",
    },
    {
        flag2: "nu",
        flag: "niu",
        name: "Niue",
    },
    {
        flag2: "nf",
        flag: "nfk",
        name: "Norfolk Island",
    },
    {
        flag2: "mp",
        flag: "mnp",
        name: "Northern Mariana Islands",
    },
    {
        flag2: "no",
        flag: "nor",
        name: "Norway",
    },
    {
        flag2: "om",
        flag: "omn",
        name: "Oman",
    },
    {
        flag2: "pk",
        flag: "pak",
        name: "Pakistan",
    },
    {
        flag2: "pw",
        flag: "plw",
        name: "Palau",
    },
    {
        flag2: "ps",
        flag: "pse",
        name: "Palestine, State of",
    },
    {
        flag2: "pa",
        flag: "pan",
        name: "Panama",
    },
    {
        flag2: "pg",
        flag: "png",
        name: "Papua New Guinea",
    },
    {
        flag2: "py",
        flag: "pry",
        name: "Paraguay",
    },
    {
        flag2: "pe",
        flag: "per",
        name: "Peru",
    },
    {
        flag2: "ph",
        flag: "phl",
        name: "Philippines",
    },
    {
        flag2: "pn",
        flag: "pcn",
        name: "Pitcairn",
    },
    {
        flag2: "pl",
        flag: "pol",
        name: "Poland",
    },
    {
        flag2: "pt",
        flag: "prt",
        name: "Portugal",
    },
    {
        flag2: "pr",
        flag: "pri",
        name: "Puerto Rico",
    },
    {
        flag2: "qa",
        flag: "qat",
        name: "Qatar",
    },
    {
        flag2: "re",
        flag: "reu",
        name: "Réunion",
    },
    {
        flag2: "ro",
        flag: "rou",
        name: "Romania",
    },
    {
        flag2: "ru",
        flag: "rus",
        name: "Russian Federation",
    },
    {
        flag2: "rw",
        flag: "rwa",
        name: "Rwanda",
    },
    {
        flag2: "bl",
        flag: "blm",
        name: "Saint Barthélemy",
    },
    {
        flag2: "sh",
        flag: "shn",
        name: "Saint Helena, Ascension and Tristan da Cunha",
    },
    {
        flag2: "kn",
        flag: "kna",
        name: "Saint Kitts and Nevis",
    },
    {
        flag2: "lc",
        flag: "lca",
        name: "Saint Lucia",
    },
    {
        flag2: "mf",
        flag: "maf",
        name: "Saint Martin (French part)",
    },
    {
        flag2: "pm",
        flag: "spm",
        name: "Saint Pierre and Miquelon",
    },
    {
        flag2: "vc",
        flag: "vct",
        name: "Saint Vincent and the Grenadines",
    },
    {
        flag2: "ws",
        flag: "wsm",
        name: "Samoa",
    },
    {
        flag2: "sm",
        flag: "smr",
        name: "San Marino",
    },
    {
        flag2: "st",
        flag: "stp",
        name: "Sao Tome and Principe",
    },
    {
        flag2: "sa",
        flag: "sau",
        name: "Saudi Arabia",
    },
    {
        flag2: "sn",
        flag: "sen",
        name: "Senegal",
    },
    {
        flag2: "rs",
        flag: "srb",
        name: "Serbia",
    },
    {
        flag2: "sc",
        flag: "syc",
        name: "Seychelles",
    },
    {
        flag2: "sl",
        flag: "sle",
        name: "Sierra Leone",
    },
    {
        flag2: "sg",
        flag: "sgp",
        name: "Singapore",
    },
    {
        flag2: "sx",
        flag: "sxm",
        name: "Sint Maarten (Dutch part)",
    },
    {
        flag2: "sk",
        flag: "svk",
        name: "Slovakia",
    },
    {
        flag2: "si",
        flag: "svn",
        name: "Slovenia",
    },
    {
        flag2: "sb",
        flag: "slb",
        name: "Solomon Islands",
    },
    {
        flag2: "so",
        flag: "som",
        name: "Somalia",
    },
    {
        flag2: "za",
        flag: "zaf",
        name: "South Africa",
    },
    {
        flag2: "gs",
        flag: "sgs",
        name: "South Georgia and the South Sandwich Islands",
    },
    {
        flag2: "ss",
        flag: "ssd",
        name: "South Sudan",
    },
    {
        flag2: "su",
        flag: "sun",
        name: "Soviet Union",
    },
    {
        flag2: "es",
        flag: "esp",
        name: "Spain",
    },
    {
        flag2: "lk",
        flag: "lka",
        name: "Sri Lanka",
    },
    {
        flag2: "sd",
        flag: "sdn",
        name: "Sudan",
    },
    {
        flag2: "sr",
        flag: "sur",
        name: "Suriname",
    },
    {
        flag2: "sj",
        flag: "sjm",
        name: "Svalbard and Jan Mayen",
    },
    {
        flag2: "sz",
        flag: "swz",
        name: "Eswatini",
    },
    {
        flag2: "se",
        flag: "swe",
        name: "Sweden",
    },
    {
        flag2: "ch",
        flag: "che",
        name: "Switzerland",
    },
    {
        flag2: "sy",
        flag: "syr",
        name: "Syrian Arab Republic",
    },
    {
        flag2: "tw",
        flag: "twn",
        name: "Taiwan, Province of China",
    },
    {
        flag2: "tj",
        flag: "tjk",
        name: "Tajikistan",
    },
    {
        flag2: "tz",
        flag: "tza",
        name: "Tanzania, United Republic of",
    },
    {
        flag2: "th",
        flag: "tha",
        name: "Thailand",
    },
    {
        flag2: "tl",
        flag: "tls",
        name: "Timor-Leste",
    },
    {
        flag2: "tg",
        flag: "tgo",
        name: "Togo",
    },
    {
        flag2: "tk",
        flag: "tkl",
        name: "Tokelau",
    },
    {
        flag2: "to",
        flag: "ton",
        name: "Tonga",
    },
    {
        flag2: "tt",
        flag: "tto",
        name: "Trinidad and Tobago",
    },
    {
        flag2: "tn",
        flag: "tun",
        name: "Tunisia",
    },
    {
        flag2: "tr",
        flag: "tur",
        name: "Turkey",
    },
    {
        flag2: "tm",
        flag: "tkm",
        name: "Turkmenistan",
    },
    {
        flag2: "tc",
        flag: "tca",
        name: "Turks and Caicos Islands",
    },
    {
        flag2: "tv",
        flag: "tuv",
        name: "Tuvalu",
    },
    {
        flag2: "ug",
        flag: "uga",
        name: "Uganda",
    },
    {
        flag2: "ua",
        flag: "ukr",
        name: "Ukraine",
    },
    {
        flag2: "ae",
        flag: "are",
        name: "United Arab Emirates",
    },
    {
        flag2: "gb",
        flag: "gbr",
        name: "United Kingdom of Great Britain and Northern Ireland",
    },
    {
        flag2: "us",
        flag: "usa",
        name: "United States of America",
    },
    {
        flag2: "um",
        flag: "umi",
        name: "United States Minor Outlying Islands",
    },
    {
        flag2: "uy",
        flag: "ury",
        name: "Uruguay",
    },
    {
        flag2: "uz",
        flag: "uzb",
        name: "Uzbekistan",
    },
    {
        flag2: "vu",
        flag: "vut",
        name: "Vanuatu",
    },
    {
        flag2: "ve",
        flag: "ven",
        name: "Venezuela (Bolivarian Republic of)",
    },
    {
        flag2: "vn",
        flag: "vnm",
        name: "Viet Nam",
    },
    {
        flag2: "vi",
        flag: "vir",
        name: "Virgin Islands (U.S.)",
    },
    {
        flag2: "wf",
        flag: "wlf",
        name: "Wallis and Futuna",
    },
    {
        flag2: "eh",
        flag: "esh",
        name: "Western Sahara",
    },
    {
        flag2: "ye",
        flag: "yem",
        name: "Yemen",
    },
    {
        flag2: "zm",
        flag: "zmb",
        name: "Zambia",
    },
    {
        flag2: "zw",
        flag: "zwe",
        name: "Zimbabwe",
    },
];